import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const avatarGroupDefaultVariants = {
  "size": "md"
}
const avatarGroupCompoundVariants = []

const avatarGroupSlotNames = [
  [
    "root",
    "AvatarGroup__root"
  ]
]
const avatarGroupSlotFns = /* @__PURE__ */ avatarGroupSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, avatarGroupDefaultVariants, getSlotCompoundVariant(avatarGroupCompoundVariants, slotName))])

const avatarGroupFn = memo((props = {}) => {
  return Object.fromEntries(avatarGroupSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const avatarGroupVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...avatarGroupDefaultVariants, ...compact(variants) })

export const avatarGroup = /* @__PURE__ */ Object.assign(avatarGroupFn, {
  __recipe__: false,
  __name__: 'avatarGroup',
  raw: (props) => props,
  variantKeys: avatarGroupVariantKeys,
  variantMap: {
  "size": [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl",
    "jb",
    "xxs",
    "mg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, avatarGroupVariantKeys)
  },
  getVariantProps
})